<template lang="pug">
#activation
  km-form(:models='$data', tipDirection='bottom', :label-width=0, ref='form')
    km-form-item(:prop='"code"', :rules='rule')
      input.wp(
        v-for='i in 4',
        ref='input',
        v-model='codes[i - 1]',
        textAlign='center',
        :key='i',
        @input='inputHandle($event, i - 1)',
        @keydown.delete='deleteHandle($event, i - 1)',
        :disabled='type === "loading"',
        :maxlength='5',
        :showClearIcon='false'
      )
    div
      .tip1
        p 1.请在《驰声听说在线激活卡》上查看激活卡密码
        p(style='margin-top: 6px') 2.默认为当前登录账号激活，激活后无法撤销，换设备登录不影响使用
  .button(:class="{disabled: code.length < 20}" @click='save')
  .vip2-container(v-if='showVipIntro')
    .text-ct(style='position: relative')
      div(
        style='position: absolute; top: 10px; width: 100%; border-top: 1px solid #fccd5c'
      )
      span.f16(
        style='position: relative; z-index: 2; padding: 0 20px; color: #ff6600; background-color: #fff'
      ) 尊享超级特权
    div(style='margin-top: 12px')
      div(style='display: flex; justify-content: space-around')
        .icon-wrapper
          img(src='/static/images/ui/vip2/ic_1.png')
          span 实时评分
        .icon-wrapper
          img(src='/static/images/ui/vip2/ic_2.png')
          span 海量自习
        .icon-wrapper
          img(src='/static/images/ui/vip2/ic_3.png')
          span 诊断报告
        .icon-wrapper
          img(src='/static/images/ui/vip2/ic_4.png')
          span 无限练习
</template>

<script>
import emitter from '../ui/src/mixins/emitter.js'
import { accountRecharge } from '@/api'
export default {
  mixins: [emitter],
  data() {
    return {
      pname: window.ConfigNew.header.name,
      codes: [],
      code: '',
      type: '',
      rule: [
        { required: true, message: '请输入激活码！' },
        {
          validator: this.validator.bind(this),
        },
      ],
      show: true,
      time: 3,
      interval: '',
      date: '',
    }
  },
  props: ['numberId', 'showVipIntro'],
  methods: {
    inputHandle(v, index) {
      if (v.target.value.length === 5 && v.target.selectionStart === 5) {
        if (this.$refs.input[index + 1]) {
          this.$refs.input[index + 1].focus()
        }
      }
    },
    deleteHandle(v, index) {
      if (!this.codes[index] && this.$refs.input[index - 1]) {
        this.$refs.input[index - 1].focus()
      }
    },
    goto() {
      this.$emit('perfectInfo', {
        type: 'perRegister',
        isPer: true,
      })
    },
    save() {
      this.$refs.form
        .validate()
        .then(() => {
          this.type = ''
          this.show = false
          this.$emit('success')
        })
        .catch(() => {
          this.type = ''
        })
    },
    validator(rule, value, callback, source, options) {
      if (!this.flag) {
        this.flag = true
        accountRecharge({
          cardPwd: this.code,
        }).then((res) => {
          this.flag = false
          if (res.status === 1) {
            callback()
          } else {
            callback(res.info)
          }
        })
      }
    },
  },
  watch: {
    codes: {
      deep: true,
      handler(v) {
        this.code = v.join('')
      },
    },
  },
  mounted() {
    this.dispatch('cover', 'changetitle', this.$t('Login.Activation.title'))
    this.$nextTick(() => {
      this.$refs.input.forEach((i, index) => {
        i.onbeforepaste = 'console.log(1)'
        i.onpaste = (a, b) => {
          this.code = (
            this.code.slice(0, index * 5 + a.target.selectionStart) +
            a.clipboardData.getData('Text')
          )
            .replace(/[^A-Z0-9]/g, '')
            .slice(0, 20)
          this.$set(this.codes, 0, this.code.slice(0, 5))
          this.$set(this.codes, 1, this.code.slice(5, 10))
          this.$set(this.codes, 2, this.code.slice(10, 15))
          this.$set(this.codes, 3, this.code.slice(15, 20))
          setTimeout(() => {
            try {
              this.$refs.input[Math.floor(this.code.length / 5)].target.focus()
            } catch (error) {
            }
          })
          return false
        }
      })
    })
  },
  destroyed() {
    clearInterval(this.interval)
  },
}
</script>

<style lang="less" scoped>
#activation {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
#activation .wp {
  width: 100px;
  height: 68px;
  border-radius: 6px;
  margin-right: 10px;
  text-align: center;
  font-size: 18px;
  color: #666666;
  line-height: 24px;
  &.active,
  &:focus {
    border-color: #ffbd7b;
  }
}
p.date {
  margin-top: 7px;
  color: #999;
  font-size: 20px;
  line-height: 26px;
}
.tip1 {
  line-height: 20px;
  font-size: 14px;
  color: #999;
  text-align: left;
}
img {
  margin-top: 36px;
}

.button {
  width: 400px;
  height: 66px;
  margin: 22px auto 0;
  background-image: url('/static/images/ui/vip2/VIP_btn_normal1.png');
  cursor: pointer;

  &.disabled {
    background-image: url('/static/images/ui/vip2/VIP_btn_hover1.png');
    cursor: not-allowed;
  }
}
.vip2-container {
  width: 460px;
  height: 210px;
  margin: 15px auto 23px;
  position: relative;
  background: url('/static/images/ui/vip2/bg_left.png') left bottom no-repeat,
    url('/static/images/ui/vip2/bg_right.png') right bottom no-repeat;
  .icon-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;

    span {
      margin-top: 14px;
      color: #666;
      line-height: 1;
    }
  }
}
</style>
<style>
#activation .wp input {
  font-size: 20px;
}
#activation .errortip.bottom {
  margin-top: 2px;
}
#activation .form-item input {
  padding-left: 0px;
  padding-right: 0px;
}
#activation .wp input[disabled] {
  background: #f4f4f4;
}
</style>



// WEBPACK FOOTER //
// src/UIO/activation.vue